import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, Typography } from '@mui/material';

export const MessageDelete = ({ onConfirm, setConfirmation, idData, dataToDelete }) => {

    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false)
        setConfirmation(false)
    }

    const goClient = () => {
        setOpen(false)
        setConfirmation(false)
        onConfirm();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" >
                Va a eliminar a: {idData}
            </DialogTitle>
            {
                dataToDelete !== '' &&
                <DialogContent dividers >
                    <Typography style={{marginRight:'5px'}} variant="caption" color='red' gutterBottom>
                        Atención:
                    </Typography>
                    <Typography style={{marginRight:'5px'}} variant="caption" gutterBottom>
                        si elimina este campo, tambien eliminará todos los datos asociados
                    </Typography>
                    <Typography variant="caption" gutterBottom>
                        {`(${dataToDelete})`}
                    </Typography>
                </DialogContent>
            }
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={goClient} autoFocus>
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    )
}